export const getPaginationNextPage = (currentPage?: number, totalPage?: number, loadMore?: boolean) => {
	const pageNext = Number(currentPage) + 1;
	const pageShift = loadMore && pageNext <= Number(totalPage) ? 1 : 0;
	const page = Number(currentPage) + pageShift;

	return page;
};
